export const changePasswordPage = () =>
  import("./ChangePasswordPage").then((m) => ({ Component: m.ChangePasswordPage }));
